import { concantQuery } from "@/utils/concatQuery";
import api from "./api";

/**
 * Get blogs.
 * @param {*} param0
 * @returns
 */
const loadDealers = ({ take, skip, search }) => {
  const query = concantQuery({ take, skip, search });
  return api.get(`/dealer/${query}`);
};


export { loadDealers };
